import { Sede } from './sede';

export class CrearSedeDto {
    sede: Sede;
    idCompanias: number[];
    idVlanSedes: number[];
    rangosCreados: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/crear-sede-dto.ts